import _get from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _assertThisInitialized from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _taggedTemplateLiteral from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
import _slicedToArray from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import { Ge as z, hi as O, bo as N, w as k, di as T, M as x, fi as R, me as B } from "./abstract-base-8edf0a84-e11d45a3.js";
import { e as E } from "./state-b4c9cc73-ee633f6c.js";
import { i as A } from "./query-24926cff-3eb94bfb.js";
import { T as P, _ as U, s as $ } from "./directive-daf4e9b6-abc0af54.js";
import { y as G, u as y, b as S, P as w, S as D } from "./directive-helpers-336ae7bb-f6343f09.js";
import { n as L } from "./breakpoints-1ea07f11-d0da757c.js";
import { A as H } from "./query-assigned-ba663908-228b08f4.js";
import { r as V } from "./utils-2e24a437-383bbd0f.js";
import "./variables-37cba309-153935bd.js";
if (!("onscrollend" in window)) {
  var l = function l(a, n, c) {
      var s = a[n];
      a[n] = function () {
        var p = Array.prototype.slice.apply(arguments, [0]);
        s.apply(this, p), p.unshift(s), c.apply(this, p);
      };
    },
    e = function e(a, n, c, s) {
      if (n != "scroll" && n != "scrollend") return;
      var p = this,
        f = t.get(p);
      if (f === void 0) {
        var d = 0;
        f = {
          scrollListener: function scrollListener(h) {
            clearTimeout(d), d = setTimeout(function () {
              i.size ? setTimeout(f.scrollListener, 100) : (p.dispatchEvent(o), d = 0);
            }, 100);
          },
          listeners: 0
        }, a.apply(p, ["scroll", f.scrollListener]), t.set(p, f);
      }
      f.listeners++;
    },
    r = function r(a, n, c) {
      if (n != "scroll" && n != "scrollend") return;
      var s = this,
        p = t.get(s);
      p !== void 0 && (p[n]--, --p.listeners > 0 || (a.apply(s, ["scroll", p.scrollListener]), t.delete(s)));
    };
  var o = new Event("scrollend"),
    i = /* @__PURE__ */new Set();
  document.addEventListener("touchstart", function (a) {
    var _iterator = _createForOfIteratorHelper(a.changedTouches),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var n = _step.value;
        i.add(n.identifier);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }, {
    passive: !0
  }), document.addEventListener("touchend", function (a) {
    var _iterator2 = _createForOfIteratorHelper(a.changedTouches),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var n = _step2.value;
        i.delete(n.identifier);
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }, {
    passive: !0
  });
  var t = /* @__PURE__ */new WeakMap();
  l(Element.prototype, "addEventListener", e), l(window, "addEventListener", e), l(document, "addEventListener", e), l(Element.prototype, "removeEventListener", r), l(window, "removeEventListener", r), l(document, "removeEventListener", r);
}
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
var M = function M(l, e, r) {
    var o = /* @__PURE__ */new Map();
    for (var _i = e; _i <= r; _i++) o.set(l[_i], _i);
    return o;
  },
  Z = P( /*#__PURE__*/function (_U) {
    _inherits(_class, _U);
    function _class(l) {
      var _this;
      _classCallCheck(this, _class);
      if (_this = _possibleConstructorReturn(this, _getPrototypeOf(_class).call(this, l)), l.type !== $.CHILD) throw Error("repeat() can only be used in text expressions");
      return _possibleConstructorReturn(_this);
    }
    _createClass(_class, [{
      key: "dt",
      value: function dt(l, e, r) {
        var o;
        r === void 0 ? r = e : e !== void 0 && (o = e);
        var i = [],
          t = [];
        var a = 0;
        var _iterator3 = _createForOfIteratorHelper(l),
          _step3;
        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var n = _step3.value;
            i[a] = o ? o(n, a) : a, t[a] = r(n, a), a++;
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
        return {
          values: t,
          keys: i
        };
      }
    }, {
      key: "render",
      value: function render(l, e, r) {
        return this.dt(l, e, r).values;
      }
    }, {
      key: "update",
      value: function update(l, _ref) {
        var _ref2 = _slicedToArray(_ref, 3),
          e = _ref2[0],
          r = _ref2[1],
          o = _ref2[2];
        var i;
        var t = G(l),
          _this$dt = this.dt(e, r, o),
          a = _this$dt.values,
          n = _this$dt.keys;
        if (!Array.isArray(t)) return this.ut = n, a;
        var c = (i = this.ut) != null ? i : this.ut = [],
          s = [];
        var p,
          f,
          d = 0,
          h = t.length - 1,
          u = 0,
          m = a.length - 1;
        for (; d <= h && u <= m;) if (t[d] === null) d++;else if (t[h] === null) h--;else if (c[d] === n[u]) s[u] = y(t[d], a[u]), d++, u++;else if (c[h] === n[m]) s[m] = y(t[h], a[m]), h--, m--;else if (c[d] === n[m]) s[m] = y(t[d], a[m]), S(l, s[m + 1], t[d]), d++, m--;else if (c[h] === n[u]) s[u] = y(t[h], a[u]), S(l, t[d], t[h]), h--, u++;else if (p === void 0 && (p = M(n, u, m), f = M(c, d, h)), p.has(c[d])) {
          if (p.has(c[h])) {
            var C = f.get(n[u]),
              I = C !== void 0 ? t[C] : null;
            if (I === null) {
              var _ = S(l, t[d]);
              y(_, a[u]), s[u] = _;
            } else s[u] = y(I, a[u]), S(l, t[d], I), t[C] = null;
            u++;
          } else w(t[h]), h--;
        } else w(t[d]), d++;
        for (; u <= m;) {
          var _C = S(l, s[m + 1]);
          y(_C, a[u]), s[u++] = _C;
        }
        for (; d <= h;) {
          var _C2 = t[d++];
          _C2 !== null && w(_C2);
        }
        return this.ut = n, D(l, s), B;
      }
    }]);
    return _class;
  }(U)),
  g = {
    BEACON_TAG_NAME: "beacon-carousel",
    DEFAULT_ACCESSIBLE_LABEL: "carousel",
    BEACON_ICON_BUTTON: "beacon-icon-button",
    HEADER_MAX_INLINE_SIZE: 1344,
    CSS_VAR_STARTING_MASK: "--starting-mask-value",
    CSS_VAR_ENDING_MASK: "--ending-mask-value",
    CSS_ZERO_PERCENTAGE: "0%",
    CSS_MASK_VALUE: "calc(var(--beacon-grid-column-size-inline) + var(--beacon-grid-gutter-size-inline))",
    CSS_VAR_WRAPPER_PADDING_INLINE: "--carousel-wrapper-padding-inline",
    DATA_METRICS_LOCATION_CAROUSEL: "CAR",
    get beaconNestedComponents() {
      return ["beacon-icon-button"];
    }
  },
  j = z(_templateObject || (_templateObject = _taggedTemplateLiteral([".visually-hidden{border:0;clip:rect(0,0,0,0);block-size:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;inline-size:1px}:host{--heritage-organism-padding: calc(3 * var(--beacon-unit-atomic));--heritage-organism-block-padding: var(--heritage-organism-padding);--heritage-dot-size: calc(.75 * var(--beacon-unit-atomic));--heritage-wrapper-space-gap: var(--beacon-carousel-wrapper-space-gap);--modern-outlook-organism-padding: var(--beacon-system-space-organism-maxi);--modern-outlook-indicator-nav-gap: var(--beacon-reference-space-3);--modern-outlook-dot-size: var(--beacon-reference-space-3);--organism-inline-padding: var(--modern-outlook-organism-padding, var(--heritage-organism-padding));--organism-block-padding: var(--beacon-system-space-organism-jumbo, var(--heritage-organism-block-padding));--carousel-wrapper-space-gap: var(--beacon-system-space-gutter, var(--heritage-wrapper-space-gap));--override-icon-button-outline-offset: var(--beacon-reference-space-2, var(--beacon-unit-subatomic));--tile-inline-size: calc(100dvw - (2 * var(--organism-inline-padding)));background-color:var(--beacon-system-color-background-0, var(--beacon-color-surface-default));letter-spacing:var(--beacon-system-font-letter-spacing-standard, var(--beacon-font-letter-spacing-default))}.header{display:flex;gap:var(--beacon-reference-space-3, var(--beacon-unit-atomic));justify-content:space-between;margin-inline:auto;padding-block:var(--beacon-reference-space-3, var(--beacon-unit-atomic));padding-inline:var(--organism-inline-padding)}.title-area{align-items:center;display:flex;flex-wrap:wrap}.component-shell{margin:auto;max-inline-size:var(--beacon-system-breakpoint-xxx-large, var(--beacon-breakpoint-xxx-large));padding-block:var(--organism-block-padding)}.item-count{font:var(--beacon-system-font-weight-light, var(--beacon-font-weight-normal)) var(--beacon-system-font-size-sans-serif-headline-50, var(--beacon-headline-font-size-50)/var(--beacon-headline-font-line-height-module-50) var(--beacon-font-family-default))}.title-text,::slotted([slot=carousel-title]){font:var(--beacon-system-font-weight-bold, var(--beacon-font-weight-bold)) var(--beacon-system-font-size-serif-headline-200, var(--beacon-headline-font-size-200)/var(--beacon-headline-font-line-height-module-200) var(--beacon-font-family-default));color:var(--beacon-system-color-text-standard, var(--beacon-color-text-important));margin:0}.title-text{padding-inline-end:var(--beacon-reference-space-3, var(--beacon-unit-atomic))}.incremental-nav{display:flex;gap:var(--beacon-reference-space-3, var(--beacon-unit-atomic))}.carousel-container{--mask-gradient: linear-gradient(90deg, rgb(0 0 0 / 0%) 0%, rgb(0 0 0 / 100%) calc(0% + (var(--organism-inline-padding) / 2)), rgb(0 0 0 / 100%) calc(100% - (var(--organism-inline-padding) / 2)), rgb(0 0 0 / 0%) 100%);-webkit-mask-image:var(--mask-gradient);mask-image:var(--mask-gradient);overflow:auto;-ms-overflow-style:none;scroll-behavior:smooth;scrollbar-width:none}.carousel-container::-webkit-scrollbar{display:none}.carousel-wrapper{display:flex;gap:var(--carousel-wrapper-space-gap);inline-size:fit-content;padding-block-end:var(--beacon-system-space-micro-maxi, var(--beacon-space-micro-maxi));padding-block-start:var(--beacon-system-space-micro-jumbo, var(--beacon-space-micro-jumbo));padding-inline:var(--organism-inline-padding)}.carousel-indicator{display:flex;gap:var(--modern-outlook-indicator-nav-gap, var(--beacon-carousel-indicator-nav-space-gap));justify-content:center;margin-inline:auto;padding-block:var(--beacon-space-cell-free-floating, var(--beacon-unit-atomic))}.carousel-indicator-dot{background:none;block-size:var(--modern-outlook-dot-size, var(--heritage-dot-size));border:var(--beacon-system-width-border-mini, var(--beacon-border-width-small)) solid var(--beacon-system-color-icon-secondary, var(--beacon-color-border-primary-focus));border-radius:var(--beacon-system-radius-corner-circle, var(--beacon-radii-circle));cursor:pointer;inline-size:var(--modern-outlook-dot-size, var(--heritage-dot-size));outline-offset:var(--beacon-reference-space-2, var(--beacon-unit-subatomic));padding:0}.carousel-indicator-dot[aria-current=true]{background:var(--beacon-system-color-icon-secondary, var(--beacon-color-border-primary-focus))}.carousel-indicator-dot:hover:not([aria-current=true]){background-clip:padding-box;background-color:var(--beacon-system-color-icon-secondary, var(--beacon-color-border-primary-focus));border:3px double var(--beacon-system-color-icon-secondary, var(--beacon-color-border-primary-focus))}::slotted([beacon-tag-name*=tile]),.carousel-wrapper ::slotted(a){inline-size:var(--tile-inline-size)}@media (min-width: 640px){:host{--heritage-organism-padding: calc(2 * var(--beacon-unit-base));--heritage-dot-size: var(--beacon-unit-atomic);--tile-inline-size: calc(50dvw - (var(--organism-inline-padding) + (.5 * var(--carousel-wrapper-space-gap))))}}@media (min-width: 960px){:host{--heritage-organism-padding: calc(7 * var(--beacon-unit-atomic));--heritage-dot-size: calc(1.5 * var(--beacon-unit-atomic));--modern-outlook-dot-size: var(--beacon-reference-space-4);--modern-outlook-indicator-nav-gap: var(--beacon-reference-space-4)}}@media (min-width: 1280px){:host{--heritage-organism-padding: calc(11 * var(--beacon-unit-atomic));--tile-inline-size: calc((100dvw - (2 * (var(--organism-inline-padding) + var(--carousel-wrapper-space-gap)))) / 3)}}@media (min-width: 1600px){:host{--heritage-organism-padding: calc(10 * var(--beacon-unit-base));--heritage-organism-block-padding: calc(11 * var(--beacon-unit-atomic));--heritage-wrapper-space-gap: calc(2 * var(--beacon-unit-base))}}@media (min-width: 1920px){:host{--modern-outlook-organism-padding: 10rem;--tile-inline-size: calc((var(--beacon-system-breakpoint-xxx-large, var(--beacon-breakpoint-xxx-large)) - (2 * (var(--organism-inline-padding) + var(--carousel-wrapper-space-gap)))) / 3)}}\n"])));
var K = Object.defineProperty,
  W = Object.getOwnPropertyDescriptor,
  b = function b(l, e, r, o) {
    for (var i = o > 1 ? void 0 : o ? W(e, r) : e, t = l.length - 1, a; t >= 0; t--) (a = l[t]) && (i = (o ? a(e, r, i) : a(i)) || i);
    return o && i && K(e, r, i), i;
  };
var v = /*#__PURE__*/function (_O) {
  _inherits(v, _O);
  function v() {
    var _this2;
    _classCallCheck(this, v);
    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(v).apply(this, arguments)), _this2.beaconTagName = g.BEACON_TAG_NAME, _this2.carouselPageMap = /* @__PURE__ */new Map(), _this2.currentNavigatorIndex = 0, _this2.carouselTitle = "", _this2.accessibleLabel = g.DEFAULT_ACCESSIBLE_LABEL, _this2.dataMetricsLocation = g.DATA_METRICS_LOCATION_CAROUSEL, _this2.itemCount = 0, _this2.scrolling = !1, _this2.navButtonScrolling = !1, _this2.applyScrollBehavior = function () {
      _this2.toggleCarouselAlphaMasking(), _this2.navButtonScrolling || _this2.handleLiteralScrolling(), _this2.scrolling = !1;
    }, _this2.reactivateHandleCarouselScroll = function () {
      var e;
      _this2.navButtonScrolling = !1, (e = _this2.carouselContainer) == null || e.removeEventListener("scrollend", _this2.reactivateHandleCarouselScroll);
    }, _this2.handleScrollEnd = V(function () {
      _this2.scrolling || _this2.scrollToNavIndex();
    }, 100), _this2.updateCarouselMap = function () {
      var e = _this2.createCarouselMap();
      (e == null ? void 0 : e.size) !== _this2.carouselPageMap.size && (_this2.carouselPageMap.clear(), _this2.carouselPageMap = new Map(e), _this2.currentNavigatorIndex = 0, _this2.removeCurrentlySelected(), _this2.addAriaCurrentRole(0), _this2.carouselContainer.scroll({
        left: 0
      }), _this2.requestUpdate());
    }, _this2.carouselResizeObserver = new ResizeObserver(_this2.updateCarouselMap), _this2.carouselIntersectionObserver = new IntersectionObserver(function (e) {
      var _iterator4 = _createForOfIteratorHelper(e),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var _r = _step4.value;
          var _o = _r.target;
          _r.intersectionRatio < 1 ? _this2.toggleCarouselItemAccessibility(_o, !0) : _this2.toggleCarouselItemAccessibility(_o, !1);
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
    }, {
      threshold: [0, 1],
      root: _assertThisInitialized(_assertThisInitialized(_this2))
    });
    return _this2;
  }
  _createClass(v, [{
    key: "handleCarouselSlotChange",
    /** Update itemCount and HTML on addition or removal of carousel objects. */value: function handleCarouselSlotChange() {
      this.itemCount = this.slottedCarouselItems.length;
    }
    /**
     * Keeps the percentage values of the masking gradient to be aligned with the inline padding of the target ~ `carousel-container`.
     * Toggles the masking when scroll bar is at the start or end.
     */
  }, {
    key: "toggleCarouselAlphaMasking",
    value: function toggleCarouselAlphaMasking() {
      this.carouselContainer && (this.carouselContainer.scrollLeft !== 0 ? this.style.setProperty(g.CSS_VAR_STARTING_MASK, g.CSS_MASK_VALUE) : this.style.setProperty(g.CSS_VAR_STARTING_MASK, g.CSS_ZERO_PERCENTAGE), this.carouselContainer.scrollLeft + this.carouselContainer.clientWidth >= this.carouselContainer.scrollWidth ? this.style.setProperty(g.CSS_VAR_ENDING_MASK, g.CSS_ZERO_PERCENTAGE) : this.style.setProperty(g.CSS_VAR_ENDING_MASK, g.CSS_MASK_VALUE));
    }
    /**
     * When scrolling is not triggered by a nav button, perform the scroll logic below.
     * This logic is for when the user literally scrolls.
     * It checks where the scrollbar is (scrollLeft property) and creates
     * a currentScrolledRatio that is a percent of the total possible scrollable area.
     * This currentScrolledRatio is compared against the scrollZoneUpperLimit of a given
     * page of tiles to determine whether or not to update the currentNavigatorIndex.
     */
  }, {
    key: "handleLiteralScrolling",
    value: function handleLiteralScrolling() {
      var e, r, o;
      var i = ((e = this.carouselContainer) == null ? void 0 : e.scrollLeft) || 0,
        t = (((r = this.carouselContainer) == null ? void 0 : r.scrollWidth) || 0) - (((o = this.carouselContainer) == null ? void 0 : o.clientWidth) || 0),
        a = i / t;
      var n = this.currentNavigatorIndex;
      for (var c = 0; c < this.carouselPageMap.size; c += 1) {
        var s = this.carouselPageMap.get(c);
        if (s != null && s.startTile && s.scrollZoneUpperLimit && a <= s.scrollZoneUpperLimit) {
          n = c;
          break;
        }
      }
      this.currentNavigatorIndex = n, this.updateSelectedNavButton();
    }
    /**
     * Scroll event listener applied to the carouselContainer.
     * It toggles alpha masking of peripheral carousel content,
     * updates scroll to appropriate page and updates selected nav buttons
     * when user scrolls literally.
     */
  }, {
    key: "handleCarouselScroll",
    value: function handleCarouselScroll() {
      this.scrolling || (window.requestAnimationFrame(this.applyScrollBehavior), this.scrolling = !0);
    }
    /**
     * Deactivates performance costly portion of the scroll event handler.
     * Used when handling scrolling of carousel via nav buttons.
     */
  }, {
    key: "deactivateHandleCarouselScrollUntilScrollend",
    value: function deactivateHandleCarouselScrollUntilScrollend() {
      var e;
      this.navButtonScrolling = !0, (e = this.carouselContainer) == null || e.addEventListener("scrollend", this.reactivateHandleCarouselScroll);
    }
    /**
     * Click event handler to update scroll to appropriate page and update selected nav button
     * @param {number} index: index of carouselItem
     */
  }, {
    key: "carouselIndicatorClickHandler",
    value: function carouselIndicatorClickHandler(e) {
      this.currentNavigatorIndex = e || 0, this.deactivateHandleCarouselScrollUntilScrollend(), this.scrollToNavIndex(), this.updateSelectedNavButton();
    }
    /**
     * Sets an indicator nav dot element's `aria-current` label attribute to `true`
     *
     * @param {number} buttonIndex: index of the button to set
     */
  }, {
    key: "addAriaCurrentRole",
    value: function addAriaCurrentRole(e) {
      var r, o;
      (o = (r = this.carouselNavigator) == null ? void 0 : r.children[e]) == null || o.setAttribute("aria-current", "true");
    }
    /**
     * Click handler for increment navigation button.
     * Increases `currentNavigatorIndex` to the next page if available
     */
  }, {
    key: "incrementNavIndex",
    value: function incrementNavIndex() {
      this.currentNavigatorIndex >= this.carouselPageMap.size - 1 || (this.currentNavigatorIndex += 1, this.deactivateHandleCarouselScrollUntilScrollend(), this.updateSelectedNavButton(), this.scrollToNavIndex());
    }
    /**
     * Click handler for decrement navigation button.
     * Decreases `currentNavigatorIndex` to the previous page if available
     */
  }, {
    key: "decrementNavIndex",
    value: function decrementNavIndex() {
      this.currentNavigatorIndex <= 0 || (this.currentNavigatorIndex -= 1, this.deactivateHandleCarouselScrollUntilScrollend(), this.updateSelectedNavButton(), this.scrollToNavIndex());
    }
    /**
     * Removes the `aria-current` attribute from all navigation buttons
     */
  }, {
    key: "removeCurrentlySelected",
    value: function removeCurrentlySelected() {
      var e;
      var r = ((e = this.carouselNavigator) == null ? void 0 : e.children) || [];
      var _iterator5 = _createForOfIteratorHelper(r),
        _step5;
      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var _o2 = _step5.value;
          _o2.removeAttribute("aria-current");
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
    }
    /**
     * triggered when a new navigation button is selected
     */
  }, {
    key: "updateSelectedNavButton",
    value: function updateSelectedNavButton() {
      this.removeCurrentlySelected(), this.addAriaCurrentRole(this.currentNavigatorIndex);
    }
    /**
     * Scrolls the appropriate card into view instead of using scrollIntoView(),
     * since scrollIntoView() can cause unintended scrolling on larger pages
     */
  }, {
    key: "scrollToNavIndex",
    value: function scrollToNavIndex() {
      var e, r, o, i;
      if (this.currentNavigatorIndex === 0) (e = this.carouselContainer) == null || e.scroll({
        left: 0
      });else {
        var _t = (o = (r = this.carouselPageMap.get(this.currentNavigatorIndex)) == null ? void 0 : r.startTile) == null ? void 0 : o.offsetLeft;
        if (_t !== void 0) {
          var a = getComputedStyle(this.carouselWrapper).getPropertyValue("padding-inline");
          (i = this.carouselContainer) == null || i.scroll({
            left: _t - parseInt(a, 10)
          });
        }
      }
    }
    /**
     * Uses lits `repeat` directive to render carousel indicator nav buttons based on the number of page views available.
     *
     * @returns {TemplateResult}
     */
  }, {
    key: "renderCarouselNavigator",
    value: function renderCarouselNavigator() {
      var _this3 = this;
      return N(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      ", "\n    "])), Z(this.carouselPageMap, function (e) {
        return e[0];
      }, function (e, r) {
        return N(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n            <button\n              class=\"carousel-indicator-dot\"\n              aria-current=", "\n              aria-label=", "\n              @click=\"", "\"\n            ></button>\n          "])), r === 0 ? "true" : k, "View Page ".concat(r + 1), function () {
          return _this3.carouselIndicatorClickHandler(r);
        });
      }));
    }
    /**
     * Toggles the `inert` html attribute on the passed in `carouselItem`
     *
     * @param {HTMLElement} carouselItem Element to toggle `inert` attribute on
     * @param {boolean} hide boolean to add or remove `inert` attribute
     */
  }, {
    key: "toggleCarouselItemAccessibility",
    value: function toggleCarouselItemAccessibility(e, r) {
      e.toggleAttribute("inert", r);
    }
    /**
     * Creates and populates a new `Map<number, { startTile: HTMLElement; scrollZoneUpperLimit: number }` object by comparing page views against the `containerWidth`
     * @returns {Map<number, { startTile: HTMLElement; scrollZoneUpperLimit: number }>} Map containing page numbers as keys and the startTile instances and the upper limit of the scroll zone for a give page as values.
     */
  }, {
    key: "createCarouselMap",
    value: function createCarouselMap() {
      var _this4 = this;
      var e;
      var r = ((e = this.carouselContainer) == null ? void 0 : e.clientWidth) || 0,
        o = /* @__PURE__ */new Map(),
        i = this.slottedCarouselItems.length;
      if (r < L.MEDIUM) this.slottedCarouselItems.forEach(function (t, a) {
        o.set(a, {
          startTile: t,
          scrollZoneUpperLimit: (a + 1) / _this4.slottedCarouselItems.length
        });
      });else if (r < L.XLARGE) {
        var _t2 = i % 2,
          a = _t2 ? this.slottedCarouselItems.length : this.slottedCarouselItems.length / 2,
          n = _t2 ? 2 : 1;
        var c = 0;
        for (var s = 0; s < i - _t2; s += 2) o.set(c, {
          startTile: this.slottedCarouselItems[s],
          scrollZoneUpperLimit: (c + 1) * n / a
        }), c += 1;
        _t2 && o.set(c, {
          startTile: this.slottedCarouselItems[i - 1],
          scrollZoneUpperLimit: 1
        });
      } else {
        var _t3 = 0;
        var _a = i % 3,
          _n = _a ? this.slottedCarouselItems.length : this.slottedCarouselItems.length / 3,
          _c = _a ? 3 : 1;
        for (var _s = 0; _s < i - _a; _s += 3) o.set(_t3, {
          startTile: this.slottedCarouselItems[_s],
          scrollZoneUpperLimit: (_t3 + 1) * _c / _n
        }), _t3 += 1;
        _a && (_a > 1 ? o.set(_t3, {
          startTile: this.slottedCarouselItems[i - 2],
          scrollZoneUpperLimit: 1
        }) : o.set(_t3, {
          startTile: this.slottedCarouselItems[i - 1],
          scrollZoneUpperLimit: 1
        }));
      }
      return o;
    }
    /**
     * Initializes resize and intersection observers on elements
     * Triggers alpha masking on intial render
     */
  }, {
    key: "firstUpdated",
    value: function firstUpdated() {
      this.slottedCarouselItems && (this.itemCount = this.slottedCarouselItems.length), this.toggleCarouselAlphaMasking(), this.carouselResizeObserver.observe(this.carouselContainer);
      var _iterator6 = _createForOfIteratorHelper(this.slottedCarouselItems),
        _step6;
      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var _e = _step6.value;
          this.carouselIntersectionObserver.observe(_e);
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }
    }
  }, {
    key: "render",
    value: function render() {
      return N(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["<section aria-label=\"", "\" class=\"component-shell\">\n      <header class=\"header\">\n        <div class=\"title-area\">\n          <span class=\"title-text\"><slot name=\"carousel-title\">", "</slot></span>\n          <span class=\"item-count\">(", " <slot name=\"item-label\">items</slot>)</span>\n        </div>\n        ", "\n      </header>\n      <div class=\"carousel-container\" @scroll=\"", "\" @scrollend=\"", "\">\n        <div class=\"carousel-wrapper\" tabindex=\"0\">\n          <slot @slotchange=", "></slot>\n        </div>\n      </div>\n      <nav class=\"carousel-indicator\" aria-label=\"main-navigation\">", "</nav>\n    </section>"])), this.accessibleLabel, this.carouselTitle, this.itemCount, this.carouselPageMap.size !== 1 ? N(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["<nav aria-label=\"page-navigation\" class=\"incremental-nav\">\n              ", "\n              ", "\n            </nav>"])), T(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["<", " @beacon-event-click=", " ?disabled=", " class=\"increment-left\" variant=\"secondary\" label=\"Go to previous page\">\n          <svg slot=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\">\n          <path d=\"M13 16.5L9 12.5L13 8.5\" stroke=\"#086EA1\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n          </svg>\n          </", ">"])), this.getScopedTag(g.BEACON_ICON_BUTTON), this.decrementNavIndex, this.currentNavigatorIndex === 0, this.getScopedTag(g.BEACON_ICON_BUTTON)), T(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["<", " @beacon-event-click=", " ?disabled=", " class=\"increment-right\" variant=\"secondary\" label=\"Go to next page\">\n          <svg slot=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\">\n          <path d=\"M11 8.5L15 12.5L11 16.5\" stroke=\"#086EA1\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n          </svg>\n          </", ">"])), this.getScopedTag(g.BEACON_ICON_BUTTON), this.incrementNavIndex, this.currentNavigatorIndex === this.carouselPageMap.size - 1, this.getScopedTag(g.BEACON_ICON_BUTTON))) : k, this.handleCarouselScroll, this.handleScrollEnd, this.handleCarouselSlotChange, this.renderCarouselNavigator());
    }
  }], [{
    key: "styles",
    get: function get() {
      return [_get(_getPrototypeOf(v), "styles", this), j];
    }
  }]);
  return v;
}(O(R));
v.tagName = g.BEACON_TAG_NAME;
v.nestedComponents = g.beaconNestedComponents;
b([E()], v.prototype, "carouselPageMap", 2);
b([E()], v.prototype, "currentNavigatorIndex", 2);
b([x({
  attribute: "carousel-title"
})], v.prototype, "carouselTitle", 2);
b([x({
  attribute: "accessible-label"
})], v.prototype, "accessibleLabel", 2);
b([x({
  attribute: "data-metrics-location",
  reflect: !0
})], v.prototype, "dataMetricsLocation", 2);
b([E()], v.prototype, "itemCount", 2);
b([H({
  selector: ":not(style)"
})], v.prototype, "slottedCarouselItems", 2);
b([A("div.carousel-container")], v.prototype, "carouselContainer", 2);
b([A("div.carousel-wrapper")], v.prototype, "carouselWrapper", 2);
b([A("section.component-shell")], v.prototype, "componentShell", 2);
b([A(".header")], v.prototype, "header", 2);
b([A("nav.carousel-indicator")], v.prototype, "carouselNavigator", 2);
export { v as BeaconCarousel };